import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Users from './pages/Users';
import Companies from './pages/Companies';
import Notifications from './pages/Notifications';
import Analytics from './pages/Analytics';
import Reports from './pages/Reports';
import MapView from './pages/MapView';
import GanttView from './pages/GanttView';
import Checklists from './pages/Checklists';
import Incidents from './pages/Incidents';
import Documents from './pages/Documents';
import ClientPortal from './pages/ClientPortal';
import ClientPortalView from './pages/ClientPortalView';
import Certificates from './pages/Certificates';
import Monitoring from './pages/Monitoring';
import Inventory from './pages/Inventory';
import Budget from './pages/Budget';
import CrewCalendar from './pages/CrewCalendar';
import Weather from './pages/Weather';
import AuditLog from './pages/AuditLog';
import ImportExport from './pages/ImportExport';
import Profitability from './pages/Profitability';

function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /><p>Cargando...</p></div>;
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" toastOptions={{ duration: 4000, style: { background: '#1E293B', color: '#F8FAFC', border: '1px solid #334155' } }} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
            <Route path="users" element={<PrivateRoute roles={['superadmin', 'admin_empresa']}><Users /></PrivateRoute>} />
            <Route path="companies" element={<PrivateRoute roles={['superadmin']}><Companies /></PrivateRoute>} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="reports" element={<Reports />} />
            <Route path="map" element={<MapView />} />
            <Route path="gantt" element={<GanttView />} />
            <Route path="checklists" element={<Checklists />} />
            <Route path="incidents" element={<Incidents />} />
            <Route path="documents" element={<Documents />} />
            <Route path="client-portal" element={<ClientPortal />} />
            <Route path="certificates" element={<Certificates />} />
            <Route path="monitoring" element={<Monitoring />} />
			<Route path="inventory" element={<Inventory />} />
			<Route path="budget" element={<Budget />} />
			<Route path="crews" element={<CrewCalendar />} />
			<Route path="weather" element={<Weather />} />
			<Route path="audit" element={<AuditLog />} />
			<Route path="import-export" element={<ImportExport />} />
                 <Route path="profitability" element={<Profitability />} />
          </Route>
          <Route path="/portal/:token" element={<ClientPortalView />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
